import { ORDERS_API_BASE } from '@/config/api';
// API для работы с чатами TalkMe
const BASE_URL = ORDERS_API_BASE + '/chat';

// Получение списка чатов
export const getChatMessages = async (payload) => {
  try {
    // Преобразуем данные в формат TalkMe API
    const requestData = {
      dateRange: payload.dateRange || {
        start: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString().slice(0, 19).replace('T', ' '),
        stop: new Date().toISOString().slice(0, 19).replace('T', ' ')
      }
    };

    // Добавляем фильтры если они есть
    if (payload.operator && payload.operator.login) {
      requestData.operator = { login: payload.operator.login };
    }
    if (payload.dialogClosed !== undefined) {
      requestData.dialogClosed = payload.dialogClosed;
    }
    if (payload.haveNoAnswer !== undefined) {
      requestData.haveNoAnswer = payload.haveNoAnswer;
    }
    if (payload.sender) {
      requestData.sender = payload.sender;
    }
    if (payload.status) {
      requestData.status = payload.status;
    }

    const response = await fetch(`${BASE_URL}/getChatMessages.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    });

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || 'Ошибка получения чатов');
    }
    
    return result.data;
  } catch (error) {
    console.error('Ошибка API getChatMessages:', error);
    throw error;
  }
};

// Получение сообщений конкретного клиента
export const getClientMessages = async (payload) => {
  try {
    // Отправляем данные в упрощенном формате для PHP обработчика
    const requestData = {
      clientId: payload.clientId,
      page: payload.page || 0,
      limit: payload.limit || 30,
      orderDirection: payload.orderDirection || 'desc',
      withAutoActionMessages: payload.withAutoActionMessages || false
    };

    const response = await fetch(`${BASE_URL}/getClientMessages.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    });

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || 'Ошибка получения сообщений');
    }
    
    return result.result;
  } catch (error) {
    console.error('Ошибка API getClientMessages:', error);
    throw error;
  }
};

// Отправка сообщения клиенту
export const sendMessageToClient = async (payload) => {
  try {
    // Отправляем данные в упрощенном формате для PHP обработчика
    const requestData = {
      clientId: payload.clientId,
      operatorLogin: payload.operatorLogin,
      messageText: payload.messageText,
      markAsRead: payload.markAsRead !== undefined ? payload.markAsRead : true,
      countInOperatorStatistic: payload.countInOperatorStatistic !== undefined ? payload.countInOperatorStatistic : true
    };

    const response = await fetch(`${BASE_URL}/sendMessage.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    });

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || 'Ошибка отправки сообщения');
    }
    
    return result.result;
  } catch (error) {
    console.error('Ошибка API sendMessageToClient:', error);
    throw error;
  }
};

// Отправка статуса набора текста
export const sendTypingStatus = async (payload) => {
  try {
    // Отправляем данные в упрощенном формате для PHP обработчика
    const requestData = {
      clientId: payload.clientId,
      operatorLogin: payload.operatorLogin,
      ttl: payload.ttl || 30
    };

    const response = await fetch(`${BASE_URL}/sendTyping.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    });

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || 'Ошибка отправки статуса набора');
    }
    
    return result.result;
  } catch (error) {
    console.error('Ошибка API sendTypingStatus:', error);
    throw error;
  }
};

// Установка статуса сообщения
export const setMessageStatus = async (payload) => {
  try {
    // Отправляем данные в упрощенном формате для PHP обработчика
    const requestData = {
      messageId: payload.messageId,
      status: payload.status
    };

    // Добавляем operatorLogin если он есть
    if (payload.operatorLogin) {
      requestData.operatorLogin = payload.operatorLogin;
    }

    const response = await fetch(`${BASE_URL}/setMessageStatus.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    });

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || 'Ошибка установки статуса сообщения');
    }
    
    return result.result;
  } catch (error) {
    console.error('Ошибка API setMessageStatus:', error);
    throw error;
  }
};

// Получение количества непрочитанных сообщений
export const getUnreadMessageCount = async (payload) => {
  try {
    // Отправляем данные в упрощенном формате для PHP обработчика
    const requestData = {
      clientId: payload.clientId
    };

    // Добавляем operatorLogin если он есть
    if (payload.operatorLogin) {
      requestData.operatorLogin = payload.operatorLogin;
    }

    const response = await fetch(`${BASE_URL}/getUnreadMessageCount.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    });

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || 'Ошибка получения количества непрочитанных сообщений');
    }
    
    return result.result;
  } catch (error) {
    console.error('Ошибка API getUnreadMessageCount:', error);
    throw error;
  }
};

// Закрытие диалога
export const closeDialog = async (payload) => {
  try {
    const response = await fetch(`${BASE_URL}/closeDialog.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || 'Ошибка закрытия диалога');
    }
    
    return result.result;
  } catch (error) {
    console.error('Ошибка API closeDialog:', error);
    throw error;
  }
};

// Перенаправление клиента
export const forwardClient = async (payload) => {
  try {
    const response = await fetch(`${BASE_URL}/forwardClient.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || 'Ошибка перенаправления клиента');
    }
    
    return result.result;
  } catch (error) {
    console.error('Ошибка API forwardClient:', error);
    throw error;
  }
};

// Обновление диалога
export const updateDialog = async (payload) => {
  try {
    const response = await fetch(`${BASE_URL}/updateDialog.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || 'Ошибка обновления диалога');
    }
    
    return result.result;
  } catch (error) {
    console.error('Ошибка API updateDialog:', error);
    throw error;
  }
};

// Получение диалога по dialogId
export const getDialog = async (payload) => {
  try {
    const requestData = {
      dialogId: payload.dialogId
    };

    const response = await fetch(`${BASE_URL}/getDialog.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    });

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || 'Ошибка получения диалога');
    }
    
    return result.data;
  } catch (error) {
    console.error('Ошибка API getDialog:', error);
    throw error;
  }
};
